import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import ListFormeFillingTable from './ListFormeFillingTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import ListFormeFilling from './ListFormeFilling'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from '../../constants/date'
import {
  deleteEfilling,
  editEfilling,
  preeviewEditEfilling,
  saveEfilling,
  searchEfilling,
  UpdateEfilling,
} from '../../redux/actions/eFilling'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function ListFormeFillingWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [previewSchema, setPreviewSchema] = useState([])
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [formDisplayLists, setFormDisplayLists] = useState()
  const [isExpanded, setIsExpanded] = useState(true)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isEditShowConfirm, setEditIsShowConfirm] = useState(false)
  const [projectCode, setProjectCode] = useState('')
  const pageNumber = 0
  const pageSize = 0
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const history = useHistory()
  const [isPreeviewFile, setIsPreeviewFile] = useState(false)
  const [ImportDataVal, setImportDataVal] = useState([])
  const [request, setRequest] = useState()
  const [searchRequest, setSearchRequest] = useState({})

  useEffect(() => {
    const projectCode = sessionStorage.getItem('projectCode')
    setProjectCode(projectCode || '')
  }, [])

  const handleGetSchemaEdit = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await editEfilling(id)
      setSelectRowData(response.model)
      // console.log('id==>', id)
      // setSelectRowData(id)
      // console.log('responseEdit==>', response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSelectRowData = async (rowData) => {
    // console.log('on Preview in Edit')
    // console.log('handleSelectRowData===>', rowData)
    //setSelectRowData(rowData)
    setIsAddBankAccount(false)
    setIsExpanded(false)
    handleGetSchemaEdit(rowData.id)
    // onsubmitPreeviewEdit(rowData.id)
  }

  const handleAddBankAccount = () => {
    clearErrors()
    setIsAddBankAccount(true)
    setIsExpanded(false)
  }

  const onSubmit = (data) => {
    // console.log('dataOnSubmit==>', data)
    // console.log('selectRowData', selectRowData)

    if (!projectCode) {
      notification.open('error', {
        title: 'ไม่พบรหัสโครงการ',
        duration: 5000,
      })
      return
    }

    let submitDate = data.submisDate
    let withholdingMonth = data.taxMonth

    if (!isNaN(Date.parse(data.submisDate))) {
      let _submisDate = new Date(data.submisDate)
      _submisDate.setHours(_submisDate.getHours() + 7)
      submitDate = _submisDate.toISOString()
    }

    if (!isNaN(Date.parse(data.taxMonth))) {
      let _taxMonth = new Date(data.taxMonth)
      _taxMonth.setHours(_taxMonth.getHours() + 7)
      withholdingMonth = _taxMonth.toISOString()
    }

    let request = {
      id: selectRowData?.id ? selectRowData.id : '',
      projectCode: projectCode || '',
      submiteFillingRefNumber: data.taxReferCode,
      submitDate: submitDate,
      withholdingType: getValueFromOptions(formSchema.forms.modelType.options, data.modelType),
      withholdingMonth: withholdingMonth,
      sequenceNo: data.submisList,
      remark: data.remark,
      eFillingImportData: ImportDataVal || [],
    }

    setRequest(request)
    setIsShowConfirm(true)
    // handleCallService(request)
  }
  const onSubmitEdit = (data) => {
    // console.log('dataOnSubmitEdit==>', data)
    const formData = new FormData()

    var submisDate
    var taxMonth
    var receiptDate

    if (!isNaN(Date.parse(data.submisDate))) {
      let _submisDate = new Date(data.submisDate)
      _submisDate.setHours(_submisDate.getHours() + 7)
      submisDate = _submisDate.toISOString()
    }
    if (!isNaN(Date.parse(data.taxMonth))) {
      let _taxMonth = new Date(data.taxMonth)
      _taxMonth.setHours(_taxMonth.getHours() + 7)
      taxMonth = _taxMonth.toISOString()
    }
    if (!isNaN(Date.parse(data.receiptDate))) {
      let _receiptDate = new Date(data.receiptDate)
      _receiptDate.setHours(_receiptDate.getHours() + 7)
      receiptDate = _receiptDate.toISOString()
    }

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    data.attachReceiptFiles &&
      data.attachReceiptFiles?.forEach((element) => {
        formData.append('BillFile', element.blobFile)
      })
    data.attachFormTaxFiles &&
      data.attachFormTaxFiles?.forEach((element) => {
        formData.append('WithholdingTaxFormFile', element.blobFile)
      })

    if (data.taxFilePath) {
      //ถ้ามี path เก่า ให้ส่งกลับมาด้วย (เพื่อไปลบใน minio)
      if (!data.isDeleteTaxFile) {
        formData.append('WithholdingTaxFormPath', data.taxFilePath)
      } else {
        formData.append('IsDeleteTaxFilePath', data.taxFilePath)
      }
    }

    if (data.billFilePath) {
      //ถ้ามี path เก่า ให้ส่งกลับมาด้วย (เพื่อไปลบใน minio)
      if (!data.isDeleteBillFile) {
        formData.append('BillFilePath', data.billFilePath)
      } else {
        formData.append('IsDeleteBillFilePath', data.billFilePath)
      }
    }

    formData.append('SubmitDate', submisDate || '')
    formData.append('WithholdingMonth', taxMonth || '')
    formData.append('BillDate', receiptDate || '')
    formData.append('SubmitFormType', data.submisFormType || '')
    formData.append('Id', selectRowData?.id ? selectRowData.id : '')
    formData.append('ProjectCode', data.projectCode || '')
    formData.append('SubmiteFillingRefNumber', data.taxReferCode || '')
    formData.append(
      'WithholdingType',
      getValueFromOptions(formSchema.forms.modelType.options, data.modelType) || ''
    )
    formData.append('SequenceNo', data.submisList || '')
    formData.append('SubmitType', data.submisType || '')
    formData.append('SubmitStatus', data.submisStatus || '')
    formData.append('SubmitSubStatus', data.submisSubStatus || '')
    formData.append('SubmitName', data.submitName || '')
    formData.append('SubmitContrctPhoneNo', data.phoneNumber || '')
    formData.append('Remark', data.remark || '')
    // console.log('formData==>', formData)

    setRequest(formData)
    setEditIsShowConfirm(true)
  }
  const handleUpdateCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await UpdateEfilling(request)
      if (response) {
        // clearValues()

        setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        //setFormSchema(response.model)
        // console.log('responseTest', response)

        //call api search for fetch data
        handleSearchEFilling(searchRequest)
        setIsPreeviewFile(false)
      } else {
        // setIsError('ล้มเหลว')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      setEditIsShowConfirm(false)
    } catch (e) {
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
      setEditIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveEfilling(request)
      if (response) {
        // clearValues()

        setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        setFormSchema(response.model)
        setIsPreeviewFile(false)
        // console.log('responseTest', response)
      } else {
        // setIsError('ล้มเหลว')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      setIsShowConfirm(false)
    } catch (e) {
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
      setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnReload = async (pageNumber, pageSize) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await searchEfilling(searchRequest || {}, pageNumber, pageSize)
      // console.log('reload response', response)
      if (response) {
        // setSchema(response)
        setFormSchema(response.model)
      }
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnDelete = async (rowData) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)
    try {
      const response = await deleteEfilling(rowData.id)
      // console.log('fff', response)
      if (response == 200) {
        handleOnReload(pageNumber, pageSize)
      } else {
        alert('เกิดความผิดพลาด')
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ลบไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const clearValues = () => {
    setValue(formSchema.bankName.name, '')
    setValue(formSchema.accountName.name, '')
    setValue(formSchema.accountNo.name, '')
    setValue(formSchema.accountType.name, '')
  }

  const handleOnSearchEFilling = async (
    submitStartDate,
    submitEndDate,
    txtModelTypeVal,
    txtSubmisTypeVal,
    txtSubmisStatusVal,
    txtDataTypeVal,
    projectcode
  ) => {
    const request = {
      submitStartDate: submitStartDate ? moment(submitStartDate).format(REQUEST_DATE_FORMAT) : '',
      submitEndDate: submitEndDate ? moment(submitEndDate).format(REQUEST_DATE_FORMAT) : '',
      withholdingType:
        getValueFromOptions(formSchema.forms.modelType.options, txtModelTypeVal) || '',
      submitType: txtSubmisTypeVal || '',
      submitStatus: txtSubmisStatusVal || '',
      dataType: txtDataTypeVal || '',
      projectCode: projectcode ? projectcode.trim() : '',
    }
    // console.log('request', request)
    setSearchRequest(request)
    handleSearchEFilling(request)
  }

  const handleSearchEFilling = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      // console.log('request', request)
      const response = await searchEfilling(request, pageNumber, pageSize)
      // console.log('response==>', response)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onsubmitPreeview = async () => {
    // console.log('on Preview in Add')
    setIsPreeviewFile(true)
  }

  const onsubmitPreeviewEdit = async () => {
    setIsLoading(true)
    startLoading()
    setIsPreeviewFile(false)
    try {
      const response = await preeviewEditEfilling(selectRowData.id)
      setPreviewSchema(response.model)
      setIsPreeviewFile(true)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={'รายการข้อมูลยื่น eFilling'}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <ListFormeFillingTable
          schema={formSchema}
          data={formSchema?.eFillingListValues}
          loading={isLoading}
          onSelect={handleSelectRowData}
          onDelete={handleOnDelete}
          isViewMode={formSchema?.disabled}
          onSearch={handleOnSearchEFilling}
          onCancel={() => {
            handleSearchEFilling({})
          }}
          handleAddBankAccount={handleAddBankAccount}
          projectCode={projectCode}
        />

        {/* {!formSchema?.disabled && (
          <IconButton
            appearance="primary"
            icon={<Icon icon="plus" />}
            onClick={() => {
              handleAddBankAccount()
            }}
            //size="sm"
            style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
          >
            เพิ่มข้อมูลยื่น eFilling
          </IconButton>
        )} */}
      </Panel>
      <br />
      {(isAddBankAccount || selectRowData) && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={isAddBankAccount ? 'เพิ่มข้อมูลยื่น eFilling' : 'แก้ไข'}
          bordered
          expanded={isExpandedForm}
          onSelect={() => {
            setIsExpandedForm(!isExpandedForm)
          }}
        >
          <ListFormeFilling
            schema={formSchema.forms}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            rowData={selectRowData}
            isAddBankAccount={isAddBankAccount}
            isPreeviewFile={isPreeviewFile}
            previewSchema={previewSchema}
            onUploadSuccess={(e) => setImportDataVal(e)}
          />

          <hr />
          {isError && <Message showIcon type="error" description={isError} />}
          <Row>
            <Col style={{ textAlign: 'end' }}>
              {isAddBankAccount ? (
                <PreviewButton onClick={onsubmitPreeview} disabled={ImportDataVal.length == 0} />
              ) : (
                <PreviewButton onClick={onsubmitPreeviewEdit} />
              )}

              {isAddBankAccount ? (
                <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
              ) : (
                <SaveButton onClick={handleSubmit(onSubmitEdit)}>{'บันทึก'} </SaveButton>
              )}

              <CancelButton
                onClick={() => {
                  setIsExpanded(true)
                  setIsAddBankAccount(false)
                  setSelectRowData()
                  clearErrors()
                  setIsPreeviewFile(false)
                }}
              >
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>

          <ConfirmWidget
            // title={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่มบัญชี' : 'แก้ไขบัญชี')}
            title="ยืนยันการบันทึก"
            show={isShowConfirm}
            // detail={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่มบัญชี' : 'แก้ไขบัญชี')}
            onCancle={() => setIsShowConfirm(false)}
            onConfirm={() => handleCallService(request)}
          />

          <ConfirmWidget
            // title={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่มบัญชี' : 'แก้ไขบัญชี')}
            title="ยืนยันการบันทึก"
            show={isEditShowConfirm}
            // detail={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่มบัญชี' : 'แก้ไขบัญชี')}
            onCancle={() => setEditIsShowConfirm(false)}
            onConfirm={() => handleUpdateCallService(request)}
          />
        </Panel>
      )}
    </>
  )
}
